import { SharedModule } from 'app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SetSignatureInfoComponent } from './set-signature-info/set-signature-info.component';
import { AcceptPolicyComponent } from './accept-policy/accept-policy.component';
import { InfoTipsComponent } from './info-tips/info-tips.component';
import { CallContactComponent } from './call-contact/call-contact.component';
import { LeftMessageComponent } from './left-message/left-message.component';
import { MeetingsResponseComponent } from './response/meetings-response/meetings-response.component';
import { LastContactsComponent } from './last-contacts/last-contacts.component';
import { ResetContentComponent } from './reset-content/reset-content.component';
import { InsertHyperlinkComponent } from './insert-hyperlink/insert-hyperlink.component';
import { ChooseFrequencyComponent } from './choose-frequency/choose-frequency.component';
import { ContactActivityComponent } from './contact-activity/contact-activity.component';
import { ContactConversationComponent } from './contact-conversation/contact-conversation.component';
import { CreateGroupComponent } from './create-group/create-group.component';
import { MessageDetailComponent } from './contact-activity/message-detail/message-detail.component';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ContactPrivateNoteComponent } from './contact-private-note/contact-private-note.component';
import { RContentComponent } from './quick-response/r-content.component';
import { UpdateProductComponent } from './update-product/update-product.component';
import { UpdatePipelineComponent } from './update-pipeline/update-pipeline.component';
import { AddAssocProductComponent } from './add-assoc-product/add-assoc-product.component';
import { QrEditComponent } from './qr-edit/qr-edit.component';
import { OneTimeMessageComponent } from './one-time-message/one-time-message.component';
import { WizardComponent } from './wizard/wizard.component';
import {
  ContactStatusSelectionStepComponent,
} from './wizard/components/contact-status-selection-step/contact-status-selection-step.component';
import {
  ContactContactSelectionStepComponent,
} from './wizard/components/contact-contact-selection-step/contact-contact-selection-step.component';
import {
  ContentCodeSelectorStepComponent,
} from './wizard/components/content-code-selector-step/content-code-selector-step.component';
import {
  ContactCreateMessageStepComponent,
} from './wizard/components/contact-create-message-step/contact-create-message-step.component';
import { ContactApproveStepComponent } from './wizard/components/contact-approve-step/contact-approve-step.component';
import { WizardService } from './wizard/wizard.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RedNoMatchDialogComponent } from './red-no-match-dialog/red-no-match-dialog.component';
import {
  SelectActionStepComponent,
} from './wizard/components/red-no-match/select-action-step/select-action-step.component';
import {
  SearchForContactComponent,
} from './wizard/components/red-no-match/search-for-contact/search-for-contact.component';
import { SelectContactComponent } from './wizard/components/red-no-match/select-contact/select-contact.component';
import {
  CreateNewContactComponent,
} from './wizard/components/red-no-match/create-new-contact/create-new-contact.component';
import {
  ContactSelectorActionsComponent,
} from './wizard/components/red-no-match/select-contact/contact-selector-actions/contact-selector-actions.component';
import { ManageContactGroupsComponent } from './manage-contact-groups/manage-contact-groups.component';
import {
  RemoveContactsFromDomainDialogComponent,
} from './remove-contacts-from-domain-dialog/remove-contacts-from-domain-dialog.component';
import {
  WaitForOneTimeMessageComponent,
} from './wizard/components/wait-for-one-time-message/wait-for-one-time-message.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { InactiveAddContactComponent } from './inactive-add-contact/inactive-add-contact.component';
import { ConfirmResetContentComponent } from './confirm-reset-content/confirm-reset-content.component';
import { SentToCampignDialogComponent } from './sent-to-campign-dialog/sent-to-campign-dialog.component';
import {
  ContactActivityMobileRowComponent,
} from './contact-activity/contact-activity-mobile-row/contact-activity-mobile-row.component';
import { FilterUsersDialogComponent } from './filter-users-dialog/filter-users-dialog.component';
import { ForwardDialogComponent } from './forward-dialog/forward-dialog.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@NgModule({
  declarations: [
    AddAssocProductComponent,
    SetSignatureInfoComponent,
    AcceptPolicyComponent,
    InfoTipsComponent,
    CallContactComponent,
    LeftMessageComponent,
    MeetingsResponseComponent,
    LastContactsComponent,
    ResetContentComponent,
    InsertHyperlinkComponent,
    ChooseFrequencyComponent,
    ContactActivityComponent,
    ContactConversationComponent,
    CreateGroupComponent,
    MessageDetailComponent,
    FileUploaderComponent,
    ContactPrivateNoteComponent,
    RContentComponent,
    UpdateProductComponent,
    UpdatePipelineComponent,
    QrEditComponent,
    OneTimeMessageComponent,
    WizardComponent,
    ContactStatusSelectionStepComponent,
    ContactContactSelectionStepComponent,
    ContentCodeSelectorStepComponent,
    ContactCreateMessageStepComponent,
    ContactApproveStepComponent,
    RedNoMatchDialogComponent,
    SelectActionStepComponent,
    SearchForContactComponent,
    SelectContactComponent,
    CreateNewContactComponent,
    ContactSelectorActionsComponent,
    ManageContactGroupsComponent,
    RemoveContactsFromDomainDialogComponent,
    WaitForOneTimeMessageComponent,
    LoadingSpinnerComponent,
    InactiveAddContactComponent,
    ConfirmResetContentComponent,
    SentToCampignDialogComponent,
    ContactActivityMobileRowComponent,
    FilterUsersDialogComponent,
    ForwardDialogComponent,

  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    NgxIntlTelInputModule,
  ],
  exports: [
    AddAssocProductComponent,
    SetSignatureInfoComponent,
    AcceptPolicyComponent,
    InfoTipsComponent,
    CallContactComponent,
    LeftMessageComponent,
    LastContactsComponent,
    ResetContentComponent,
    InsertHyperlinkComponent,
    ChooseFrequencyComponent,
    RContentComponent,
    CreateGroupComponent,
    QrEditComponent,
    OneTimeMessageComponent,
    WizardComponent,
    ContactStatusSelectionStepComponent,
    ContactContactSelectionStepComponent,
    ContentCodeSelectorStepComponent,
    ContactCreateMessageStepComponent,
    ContactApproveStepComponent,
    WaitForOneTimeMessageComponent,
    FilterUsersDialogComponent,

  ],
  providers: [WizardService],
})
export class DialogsModule {
}
